export default function ruleReducer(rule, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...rule, [action.type]: action.value };
  }
}
